import { StudentCreateOnUpdateDataMiddleWare } from "raft/StudentForm";

const onUpdateUpdateMiddlewareStudentAndBewerber: StudentCreateOnUpdateDataMiddleWare = ({ data }) => {
  const studentFullName = `${data.vorname ?? ""} ${data.nachname ?? ""}`;
  return { ...data, summaryOne: studentFullName };
};

export default onUpdateUpdateMiddlewareStudentAndBewerber;
